// import { Grid } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSDataGridNew, { IColumns } from "../../../Components/DataGrid/WSDataGridNew";
// import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
// import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { useNavigate } from "react-router-dom";

// export const PharmacyOrder:React.FC<any>=React.memo((props)=>{
//     const navigate = useNavigate();

//   const filters = ["All", "Pending","Packed","Ready to dispatch","Out for delivery","Delivered","cancelled"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);

 
//   const columns: IColumns[] = [
    
  
//     {
//       header: "Patient ",
//       fieldName: "price",
//       type: "default",
//     },
//     {
//       header: "Order ID",
//       fieldName: "",
//       type: "default",
//       // sortable: true
//     },
//     {
//       header: "Price",
//       fieldName: "price",
//       type: "default",
//     },
//       {
//       header: "Items",
//       fieldName: "mode",
//       type: "default",
//     },
//     {
//       header: "Payment",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Order Date",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Status",
//       fieldName: "status",
//       type: "status",
//     },

//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Edit"].filter(Boolean),
//       // actionCallback: (action, row) => handleAction(action, row),
//       // hideSelectedActions: {
//       //     fieldToHide: [
//       //         {
//       //             field: 'status',
//       //             hideValue: ['Incomplete'],
//       //             hideActions: ['Edit']
//       //         },
//       //         // {
//       //         //     field: 'profileStatus',
//       //         //     hideValue: ['Approved'],
//       //         //     hideActions: ['Approve']
//       //         // }
//       //     ]
//       // }
//     },
//   ];
//   const filterRows: IHeaderRows[] = [
//     {
//       label: "Payment",
//       fieldName: "IsProfileComplete",
//       type: "dropdown",
//       options: [
//         { label: "All", value: "true" },
//         { label: "Home", value: "false" },
//         { label: "Center", value: "false" },
//       ],
//       operator: "eq",
//       rowDivision: 3,
//     },
   
//     {
//       label: "By Date",
//       fieldName: "",
//       type: "date",
//       operator: "like",
//       rowDivision: 6,
//     },
//   ];

//   const handleClick = async () => {
//     navigate(`/lab-orders/add`);
//   };
//   return (
//     <>
       

//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         {
//           <Grid item sm={12}>
//             <WSDataGridNew
//               columns={columns}
//               id="vendorProductListGrid"
//               title="Products"
//               exportCsv={true}
//               filterFields={filterRows}
//               addButton={{ label: "New", color: "secondary" }}
//               onAddButtonClick={handleClick}
//               searchBox={{ fieldName: "name" }}
//               gridHeaderSx={{
//                 backgroundColor: "whitesmoke",
//                 border: "1px solid whitesmoke",
//               }}
//             />
//           </Grid>
//         }
//       </Grid>
//     </>
//   )
// })







import { Grid, Snackbar, Alert } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import WSDataGridNew, { IColumns } from "../../../Components/DataGrid/WSDataGridNew";
import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
import { useNavigate } from "react-router-dom";
import http from "../../../commonFunctions/httpClient";
import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";
import { UpdateStatus } from "./updateStatus"; // ✅ Import UpdateStatus

interface PharmacyOrder {
  id: string;
  orderId: string;
  patientName: string | null;
  price: number;
  itemsCount: number;
  paymentStatus: string;
  orderDate: string;
  status: string;
  actions: string;
}

export const PharmacyOrder: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  
  const [vendorId, setVendorId] = useState<string>("");
  const [orders, setOrders] = useState<PharmacyOrder[]>([]);
  const [loading, setLoading] = useState(true);

  // ✅ Status Dialog State
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<string | null>(null);
  const [selectedStatus, setSelectedStatus] = useState("");

  // ✅ Snackbar State
  const [snackbar, setSnackbar] = useState<{ 
    open: boolean; 
    message: string; 
    severity: 'success' | 'error' 
  }>({
    open: false,
    message: '',
    severity: 'success'
  });

  // ✅ Get vendorId from localStorage
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    setVendorId(userId || "");
  }, []);

  const fetchOrders = useCallback(async () => {
    if (!vendorId) {
      console.log("⏳ Waiting for vendorId...");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      console.log("📡 FETCHING ORDERS FOR VENDOR:", vendorId);
      const response: any = await http.get(`pharmacy/ph_order_/ByVendor/${vendorId}`);
      console.log("📦 FULL API RESPONSE:", response);
      
      let data: PharmacyOrder[] = [];
      if (response && Array.isArray(response.data)) {
        data = response.data.map((order: any) => ({
          id: order.orderId, 
          orderId: order.orderId || order.orderNumber || "N/A", 
          patientName: order.userName || "Unknown", 
          price: order.totalAmount || 0, 
          itemsCount: order.itemCount || 0, 
          paymentStatus: order.paymentMethod || "N/A", 
          orderDate: order.orderDate || "N/A", 
          status: order.status || "Pending", 
          actions: order.orderId // ✅ Required for actions column
        }));
      }
      
      console.log("📦 TRANSFORMED DATA:", data);
      setOrders(data);
    } catch (error: any) {
      console.error("💥 API ERROR:", error);
      setOrders([]);
      setSnackbar({
        open: true,
        message: "Failed to load orders",
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  }, [vendorId]);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  // ✅ Status Change Handlers
  const handleStatusChangeClick = useCallback((orderId: string) => {
    setSelectedOrder(orderId);
    setConfirmOpen(true);
  }, []);

  const handleConfirmStatusChange = useCallback(async () => {
    if (selectedOrder && selectedStatus && vendorId) {
      try {
        console.log("📤 UPDATING STATUS:", { orderId: selectedOrder, status: selectedStatus, vendorId });
        
        // ✅ CORRECT API ENDPOINT
        const response: any = await http.put(`pharmacy/Ph_Order_/update-status`, {
          orderId: selectedOrder,
          status: selectedStatus,
          vendorId: vendorId
        });

        console.log("✅ STATUS UPDATE RESPONSE:", response);

        if (response?.success) {
          // ✅ Update local state immediately (optimistic update)
          setOrders(prevOrders => 
            prevOrders.map(order => 
              order.id === selectedOrder 
                ? { ...order, status: selectedStatus }
                : order
            )
          );
          
          setSnackbar({
            open: true,
            message: `Order status updated to ${selectedStatus}`,
            severity: 'success'
          });
        } else {
          throw new Error(response?.message || "Status update failed");
        }
      } catch (error: any) {
        console.error("💥 Status Update Error:", error);
        setSnackbar({
          open: true,
          message: error?.response?.data?.message || error?.message || "Failed to update status",
          severity: 'error'
        });
      }
    }
    
    // ✅ Reset dialog
    setConfirmOpen(false);
    setSelectedOrder(null);
    setSelectedStatus("");
  }, [selectedOrder, selectedStatus, vendorId]);

  const handleCancelStatusChange = useCallback(() => {
    setConfirmOpen(false);
    setSelectedOrder(null);
    setSelectedStatus("");
  }, []);

  // ✅ Action Handler
  const handleAction = useCallback((action: string, row: PharmacyOrder) => {
    console.log("🔧 ACTION:", action, "ROW:", row);
    
    switch (action) {
      case "Update Status":
        handleStatusChangeClick(row.id);
        break;
      case "View":
        navigate(`/pharmacy-order-details/${row.id}`);
        break;
      // case "Edit":
      //   navigate(`/pharmacy-orders/edit/${row.id}`);
      //   break;
      default:
        console.log("Unknown action:", action);
    }
  }, [navigate, handleStatusChangeClick]);

  const columns: IColumns[] = [
    { header: "Patient", fieldName: "patientName", type: "default" },
    { header: "Order ID", fieldName: "orderId", type: "default" },
    { header: "Price", fieldName: "price", type: "default" },
    { header: "Items", fieldName: "itemsCount", type: "default" },
    { header: "Payment", fieldName: "paymentStatus", type: "status" },
    { header: "Order Date", fieldName: "orderDate", type: "date" },
    { header: "Status", fieldName: "status", type: "status" },
    { 
      header: "Actions", 
      fieldName: "actions", 
      type: "action", 
      actions: ["Update Status", "View"],
      actionCallback: handleAction,
    },
  ];

  const filterRows: IHeaderRows[] = [
    {
      label: "Status",
      fieldName: "status",
      type: "dropdown",
      options: [
        // { label: "All", value: "" },
        { label: "Pending", value: "Pending" },
        { label: "packed", value: "packed" },
        { label: "Shipped", value: "Shipped" },
        { label: "Delivered", value: "Delivered" },
        
      ],
      operator: "eq",
      rowDivision: 3,
    },
    {
      label: "By Date",
      fieldName: "orderDate",
      type: "date",
      operator: "gte",
      rowDivision: 6,
    },
  ];

  const handleAddClick = useCallback(() => {
    navigate(`/pharmacy-orders/add`);
  }, [navigate]);

  const handleSnackbarClose = useCallback(() => {
    setSnackbar({ open: false, message: '', severity: 'success' });
  }, []);

  if (loading) {
    return (
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <div>Loading orders...</div>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12}>
          <WSDataGridNew
            columns={columns}
            id="pharmacyOrderListGrid"
            title={`Pharmacy Orders - Vendor ${vendorId.substring(0, 8)}... (${orders.length})`}
            exportCsv={true}
            filterFields={filterRows}
            data={orders}
            searchBox={{ fieldName: "patientName" }}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
            addButton={{ label: "New Order", color: "secondary" }}
            onAddButtonClick={handleAddClick}
          />
        </Grid>
      </Grid>

      {/* ✅ UpdateStatus Dialog */}
      <UpdateStatus 
        confirmOpen={confirmOpen}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        handleCancelStatusChange={handleCancelStatusChange}
        handleConfirmStatusChange={handleConfirmStatusChange}
      />

      {/* ✅ Snackbar Notifications */}
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={4000} 
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleSnackbarClose} 
          severity={snackbar.severity} 
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
});

export default PharmacyOrder;
